import React from 'react'
import {FaCheckCircle} from 'react-icons/fa'

import styles from './styles.module.css'

export default function SuccessBox({message, style}) {
  return (
    <>
      {!message ? null : (
        <div className={styles.container}>
          <div className={styles.inner} style={style}>
            <FaCheckCircle size={15} className={styles.icon} />
            {message}
          </div>
        </div>
      )}
    </>
  )
}
